export const environment = {
    // host: 'https://seller.uzum.plus',
    host: 'https://api-dev.uzum.plus',
    production: true,
    // botName: 'uzumplusbot',
    botName: 'dev_jflux_seller_bot',
    paycomCheckoutUrl: 'https://checkout.test.paycom.uz/',
    yandexMapsApiKey: '6581be9a-16f2-4d4f-b936-db8a1107900d'
};
